import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { appbarFactory } from '@mews-distributor/ui';

import { LanguageSelector } from '@mews/business-components';
import { LanguageSelectDialog } from '@mews/gx-ui';
import {
    getCurrencyCode,
    getIsFxMulticurrencyServiceEnabled,
    getLanguageCode,
    isAppInitialized,
} from '../../../modules/app/selectors';
import { isClosable } from '../../../modules/app/viewSelectors';
import { getCurrentReservationGroupPaymentGatewayCurrencyCode } from '../../../views/checkout/data/viewSelectors/selectors';
import { closeApp } from '../../../modules/global/actions';
import { setCurrency } from '../../../modules/global/currencyCode';
import { setLanguage } from '../../../modules/global/languageCode';
import {
    createLocalizePropertySelector,
    getSortedCurrencies,
    getSortedLanguages,
} from '../../../modules/globalization/selectors';
import {
    getSelectedEnterpriseImageId,
    getSelectedEnterpriseName,
} from '../../../selectors/views/selectedEnterprise/selectedEnterprise';
import { DistributorThunkAction, ApplicationState } from '../../../types';
import { showCurrencySelect, showPropertyInfo } from '../Navbar/menuSelectors';
import { Logo as PropertyLogo } from './Logo';

interface LogoWrapperProps {
    propertyName: string;
    imageProps?: { id: string };
    isMobile?: boolean;
}

const LogoWrapper = ({ propertyName, imageProps, isMobile }: LogoWrapperProps) => {
    if (imageProps?.id == null) {
        return null;
    }

    return <PropertyLogo image={imageProps.id} propertyName={propertyName} isMobile={isMobile} />;
};

const MewsAppbar = appbarFactory({ Logo: LogoWrapper, LanguageSelector, LanguageSelectDialog });

const BaseAppbar = ({ isLoaded, ...other }: $TSFixMe) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (!isLoaded) {
        return null;
    }

    return <MewsAppbar role="banner" {...other} />;
};

const onLanguageChange =
    (languageCode: string): DistributorThunkAction =>
    (dispatch) => {
        dispatch(setLanguage(languageCode));
    };

const onCurrencyChange =
    (currencyCode: string): DistributorThunkAction =>
    (dispatch) => {
        void dispatch(setCurrency({ currencyCode }));
    };

export const Appbar = connect(
    createStructuredSelector<ApplicationState, $TSFixMe, $TSFixMe>({
        isLoaded: isAppInitialized,
        showCloseButton: isClosable,
        language: getLanguageCode,
        currency: getCurrencyCode,
        propertyName: createLocalizePropertySelector(getSelectedEnterpriseName),
        propertyImageId: getSelectedEnterpriseImageId,
        paymentGatewayCurrencyCode: getCurrentReservationGroupPaymentGatewayCurrencyCode,
        showPropertyInfo,
        showCurrencySelect,
        currencies: getSortedCurrencies,
        languages: getSortedLanguages,
        isFxMulticurrencyServiceEnabled: getIsFxMulticurrencyServiceEnabled,
    }),
    {
        onClose: closeApp,
        onCurrencyChange,
        onLanguageChange,
    }
)(BaseAppbar);
